export default __webpack_public_path__ + "static/media/goat_503.3d5061a0.svg";